import React, {lazy, ReactElement} from "react";
import {useAuth0} from "@auth0/auth0-react";
import {useQuery} from "@apollo/client";
import {Routes, Route} from "react-router-dom";

const Dashboard = lazy(() => import("routes/dashboard"));
const Interests = lazy(() => import("routes/interests"));
const Brands = lazy(() => import("routes/brands"));
const Profile = lazy(() => import("routes/profile"));
const TermOfService = lazy(() => import("routes/profile/terms-of-service"));
const LayoutWithNavbar = lazy(() => import("routes/LayoutWithNavbar"));
const Settings = lazy(() => import("routes/profile/settings"));
const PersonalProfile = lazy(() => import("routes/profile/personal"));
const Login = lazy(() => import("routes/login"));

import {CHECK_LOGIN} from "graphql/queries/queries";
import {LoadingPage} from "components/loading-page";
import {UserContextProvider} from "context/user-context";
import {ToastContextProvider} from "context/toast-context";

import "./App.scss";

function App() : ReactElement {
	const {isLoading, isAuthenticated, user} = useAuth0();
	const {data} = useQuery(CHECK_LOGIN, {skip: isLoading || !isAuthenticated});

	if (isLoading) {
		return <LoadingPage />;
	}

	if (isAuthenticated && user && data && data.me !== null) {
		localStorage.setItem("csrfToken", data.csrfToken);

		return (
			<UserContextProvider>
				<ToastContextProvider>
					<Routes>
						<Route path="/" element={<LayoutWithNavbar />}>
							<Route index element={<Dashboard />} />
							<Route path="/interests" element={<Interests />} />
							<Route path="/brands" element={<Brands />} />
						</Route>
						<Route path="/profile" element={<Profile />}>
							<Route path="/profile/personal" element={
								<PersonalProfile header="Personal Profile" />
							} />
							<Route path="/profile/tos" element={<TermOfService />} />
							<Route path="/profile/settings" element={<Settings />} />
						</Route>
					</Routes>
				</ToastContextProvider>
			</UserContextProvider>
		);
	}

	return (
		<Routes>
			<Route path="/*" element={<Login />} />
		</Routes>
	);
}

export default App;
